// src/shared/lib/notification/notification.js

const listeners = new Set();
let notifications = [];

const notify = () => {
    listeners.forEach(listener => listener([...notifications]));
};

export const notificationService = {
    init() {
        notifications = [];
        notify();
    },

    subscribe(listener) {
        listeners.add(listener);
        // Одразу віддаємо поточний стан при підписці
        listener([...notifications]);
        return () => {
            listeners.delete(listener);
        };
    },

    // Метод add для створення нових сповіщень
    add(message, type = 'info', duration = 3000, actions = null, existingId = null) {
        const id = existingId || crypto.randomUUID();
        const newNotification = { id, message, type, duration, actions };
        
        notifications.push(newNotification);
        notify();

        // Повідомлення автоматично зникає лише якщо немає кнопок дій і тривалість > 0
        if (!actions && duration > 0) {
            setTimeout(() => this.remove(id), duration);
        }
    },

    remove(id) {
        notifications = notifications.filter(n => n.id !== id);
        notify();
    },

    // Зручні методи для виклику
    success(msg, duration, actions) { this.add(msg, 'success', duration, actions); },
    error(msg, duration, actions) { this.add(msg, 'error', duration, actions); },
    info(msg, duration, actions) { this.add(msg, 'info', duration, actions); },
    warning(msg, duration, actions) { this.add(msg, 'warning', duration, actions); },
};
